import React, { useState } from 'react'
import { Button, Collapse } from 'reactstrap'
import { ReadOnlyInput } from '../Form/Fields'

export default function RowExtraFields({ extraFields }) {
  const [open, setOpen] = useState(false)
  return (
    <div>
      <div className="d-flex align-items-center justify-content-center mb-1">
        <Button outline type="button" size="sm" onClick={() => setOpen(!open)}>
          {!open && <small>{'+ '}Mostra campi aggiuntivi</small>}
          {open && <small>{'- '}Nascondi campi aggiuntivi</small>}
        </Button>
      </div>
      <Collapse isOpen={open}>
        <div className="row px-3 mb-2">
          {Object.keys(extraFields).map((key) => (
            <div className="col-md-2 mt-2" key={key}>
              <ReadOnlyInput label={<i>{key}</i>} value={extraFields[key]} />
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  )
}
